import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"
import type {NodeClassImpl} from "#template/runtime-graph/types"
import type {LiveValueAccessor} from "#template/interactions"
import type {PositionControlPoint as PositionControlPointData, UVControlPoint as UVControlPointData} from "#template/nodes/object/curve/types"

const TD = TypeDescriptors

type ControlPointsData = PositionControlPointData[] | UVControlPointData[]

export class LiveControlPointsValueState {
    isInteracting = false
    liveValue: ControlPointsData | undefined = undefined
}

const liveControlPointsValueDescriptor = {
    state: TD.inlet(TD.Identity<LiveControlPointsValueState>()),
    value: TD.inlet<ControlPointsData>(TD.JSON()),
    output: TD.outlet<ControlPointsData>(TD.Identity()),
    accessor: TD.outlet(TD.Identity<LiveValueAccessor<ControlPointsData>>()),
}

export class LiveControlPointsValue
    implements LiveValueAccessor<ControlPointsData>, NodeClassImpl<typeof liveControlPointsValueDescriptor, typeof LiveControlPointsValue>
{
    static descriptor = liveControlPointsValueDescriptor
    static uniqueName = "LiveControlPointsValue"
    state!: Inlet<LiveControlPointsValueState>
    value!: Inlet<ControlPointsData>
    output!: Outlet<ControlPointsData>
    accessor!: Outlet<LiveValueAccessor<ControlPointsData>>

    run() {
        if (this.state === NotReady || this.value === NotReady) {
            this.accessor.emitIfChanged(NotReady)
            this.output.emitIfChanged(NotReady)
            return
        }
        this.accessor.emitIfChanged(this)
        this.output.emitIfChanged(this.state.isInteracting && this.state.liveValue !== undefined ? this.state.liveValue : this.value)
    }

    setLiveValue(value: ControlPointsData) {
        if (this.state === NotReady) return
        this.state.isInteracting = true
        this.state.liveValue = value
        this.output.emitIfChanged(value)
    }

    endInteraction() {
        if (this.state === NotReady) return
        this.state.isInteracting = false
        this.state.liveValue = undefined
    }
}
